"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphQLApiProvider = void 0;
const handleApolloClientRequest_1 = require("../client/apollo/handleApolloClientRequest");
const ApiProvider_1 = require("./ApiProvider");
class GraphQLApiProvider extends ApiProvider_1.ApiProvider {
    constructor() {
        super(...arguments);
        this._linkOptions = {
            useAutomaticPersistedQueries: false,
            useGETAutomaticPersistedQueries: false,
        };
    }
    async query(options) {
        const response = await (0, handleApolloClientRequest_1.handleApolloClientQuery)(options, this._api, this._linkOptions);
        return response;
    }
    async mutation(options) {
        const response = await (0, handleApolloClientRequest_1.handleApolloClientMutation)(options, this._api, this._linkOptions);
        return response;
    }
    setLinkOptions({ useAutomaticPersistedQueries, useGETAutomaticPersistedQueries }) {
        this._linkOptions.useAutomaticPersistedQueries = useAutomaticPersistedQueries;
        this._linkOptions.useGETAutomaticPersistedQueries = useGETAutomaticPersistedQueries;
        return this;
    }
}
exports.GraphQLApiProvider = GraphQLApiProvider;
//# sourceMappingURL=GraphQLApiProvider.js.map